import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { contribBiennaleContributoRules } from './contrib-biennale-contributo.rules';
import { contribBiennalePagamentiRules } from './contrib-biennale-pagamenti.rules';
import { contribBiennaleDatiSorgenteRules } from './contrib-biennale-dati-sorgente.rules';
import { contribBiennaleEdiliziaDateRules } from './contrib-biennale-edilizia-date.rules';

export const contribBiennaleRules: FormGroupRules = {
    ...contribBiennaleContributoRules,
    ...contribBiennalePagamentiRules,
    ...contribBiennaleDatiSorgenteRules,
    ...contribBiennaleEdiliziaDateRules,
};

export const contribBiennaleFormValidators = Object.values(contribBiennaleRules);
